import { prettyJson } from "../../../common/CCUtils"
import { log } from "../../../common/Logging"

export enum DrTimeStages {
    PATIENT_VAPER,
    PATIENT_SMOKER,
    FINISHED
}

export class DrTimeProgressStore {

    private static innerInstance: DrTimeProgressStore

    patientCompletedStages: Array<DrTimeStages> = []
    lastPatientCompleted: DrTimeStages

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static destroy() {
        return this.innerInstance = null
    }

    static get stagesComplete(): boolean {
        return DrTimeProgressStore.instance.patientVaperStageFinished
            && DrTimeProgressStore.instance.patientSmokerStageFinished
    }

    get patientVaperStageFinished(): boolean {
        return this.patientCompletedStages.includes(DrTimeStages.PATIENT_VAPER)
    }

    get patientSmokerStageFinished(): boolean {
        return this.patientCompletedStages.includes(DrTimeStages.PATIENT_SMOKER)
    }

    addStage = (stage: DrTimeStages) => {
        if (!this.patientCompletedStages.includes(stage)) {
            this.patientCompletedStages.push(stage)
        }
        this.lastPatientCompleted = stage
        log.debug(prettyJson(this.patientCompletedStages))
    }
}